/**
 * useAppVersion
 *
 * Holt Version und Build-Kennung aus GET /api/version (öffentlich, ohne Login).
 * Die Angaben ändern sich erst mit dem nächsten Deploy - deshalb wird pro
 * Seitenaufruf genau einmal geladen und danach aus dem Modul-Zwischenspeicher
 * bedient.
 *
 * Fehlerfall: null. Eine fehlende Versionsangabe darf nie eine Seite blockieren.
 */

import { useEffect, useState } from 'react';
import { getVersion, VersionResponse } from '../api/client';

let laufenderAbruf: Promise<VersionResponse> | null = null;

export function useAppVersion(): VersionResponse | null {
  const [info, setInfo] = useState<VersionResponse | null>(null);

  useEffect(() => {
    let aktiv = true;

    laufenderAbruf ??= getVersion();
    laufenderAbruf
      .then((daten) => {
        if (aktiv) setInfo(daten);
      })
      .catch(() => {
        laufenderAbruf = null;
      });

    return () => {
      aktiv = false;
    };
  }, []);

  return info;
}
